var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#112268;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.307 0.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14,
    height: 13,
    transform: "translate(-0.307 -0.285)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.083 0.633)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.192,4.064H10.16V2.516A.518.518,0,0,0,9.644,2H7.58a.518.518,0,0,0-.516.516V4.064H6.032A1.035,1.035,0,0,0,5,5.1v5.676A1.035,1.035,0,0,0,6.032,11.8a.516.516,0,1,0,1.032,0h3.1a.516.516,0,0,0,1.032,0,1.035,1.035,0,0,0,1.032-1.032V5.1A1.035,1.035,0,0,0,11.192,4.064Zm-3.87,6.192H6.548V5.612h.774Zm1.677,0H8.225V5.612H9Zm.387-6.192H7.838V2.774H9.386Zm1.29,6.192H9.9V5.612h.774Z",
    transform: "translate(-5 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.91ba81e3912f54ab39a2e0d682e7b804.svg";
export { ForwardRef as ReactComponent };